import * as React from 'react';
import {Party} from "@ferry/journey-services";
import {PluginTemplates} from "../../utils/PluginTemplates";

interface IProps {
    party: Party;
}


export class PersonalDetailsWidget extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render(): React.ReactNode {
        if (this.props.party) {
            return (
                <>
                    <div>
                        <div className="panel-detail-output-entity personal-details-name">
                            <p className="font-weight-bold">{this.props.party.firstName} {this.props.party.lastName}</p>
                        </div>
                        <div className="panel-detail-output-entity">
                            <label className="account-details date-of-birth">Date of birth:</label>
                            {PluginTemplates.convertDate(this.props.party.dateOfBirth, "D MMMM YYYY")}
                        </div>
                    </div>
                </>
            )
        }
        return <></>
    }
}
